import { render, staticRenderFns } from "./AliasEditIcon.vue?vue&type=template&id=5e993f3a&"
import script from "./AliasEditIcon.vue?vue&type=script&lang=js&"
export * from "./AliasEditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports